import React from 'react';

import WidgetPaper from '@components/widgets/display-widget/WidgetPaper';
import WidgetSection from '@components/widgets/display-widget/WidgetSection';
import { MAIN_THEME } from '@styles';
import {
  trimTrailingZeros,
  valueCommaSeparated
} from '@utils/formatting-utils';

import { AmendmentDetails } from '../types/getAmendmentsDetailsResponse.types';

import { makeStyles } from 'tss-react/mui';

type Props = {
  data: AmendmentDetails;
  currencySymbol: string;
};

const useStyles = makeStyles()(() => ({
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '8px'
  },
  headerRow: {
    backgroundColor: MAIN_THEME.color.white98,
    borderBottom: `1px solid ${MAIN_THEME.color.lightGray}`
  },
  headerCell: {
    padding: '12px 16px',
    textAlign: 'left',
    fontWeight: 600,
    fontSize: MAIN_THEME.fontSize.sm,
    color: MAIN_THEME.color.black,
    borderBottom: `2px solid ${MAIN_THEME.color.lightGray}`
  },
  bodyRow: {
    borderBottom: `1px solid ${MAIN_THEME.color.lightGray}`,
    '&:hover': {
      backgroundColor: MAIN_THEME.color.white98
    }
  },
  bodyCell: {
    padding: '12px 16px',
    fontSize: MAIN_THEME.fontSize.sm,
    color: MAIN_THEME.color.black
  },
  coverCell: {
    fontWeight: 500
  },
  currencyCell: {
    textAlign: 'right'
  }
}));

const RemovedPolicyCoversWidgetAtom: React.FC<Props> = ({
  data,
  currencySymbol
}) => {
  const { classes } = useStyles();

  const removedCovers = (data?.policyCovers ?? []).filter(
    (cover) => cover.isRemoved === true
  );

  if (removedCovers.length === 0) {
    return null;
  }

  return (
    <WidgetPaper>
      <WidgetSection title="Removed Policy Covers" useSeparator={false}>
        <table className={classes.table}>
          <thead>
            <tr className={classes.headerRow}>
              <th className={classes.headerCell}>Policy Cover</th>
              <th className={`${classes.headerCell} ${classes.currencyCell}`}>
                Sum Insured
              </th>
              <th className={`${classes.headerCell} ${classes.currencyCell}`}>
                Premium
              </th>
            </tr>
          </thead>
          <tbody>
            {removedCovers.map((cover, index) => {
              const coverLabel = cover.policyCover || '-';
              const sumInsured = cover.sumInsured ?? 0;
              const premium = cover.premiumAmount ?? 0;

              return (
                <tr key={index} className={classes.bodyRow}>
                  <td className={`${classes.bodyCell} ${classes.coverCell}`}>
                    {coverLabel}
                  </td>
                  <td className={`${classes.bodyCell} ${classes.currencyCell}`}>
                    {currencySymbol}{' '}
                    {valueCommaSeparated(
                      trimTrailingZeros(sumInsured, 3, true)
                    )}
                  </td>
                  <td className={`${classes.bodyCell} ${classes.currencyCell}`}>
                    {currencySymbol}{' '}
                    {valueCommaSeparated(trimTrailingZeros(premium, 3, true))}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </WidgetSection>
    </WidgetPaper>
  );
};

export { RemovedPolicyCoversWidgetAtom };
